<script>
export default {
  name: 'BaseCardItem',
  functional: true,
  props: {
    label: {
      type: String,
    },
    highlight: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    divided: {
      type: Boolean,
      default: false,
    },
    dividedBottom: {
      type: Boolean,
      default: false,
    },
    paddingX: {
      type: String,
      default: 'px-24',
    },
    paddingY: {
      type: String,
      default: 'py-16',
    },
    rightBorder: {
      type: Boolean,
      default: false,
    },
    showThumbnail: {
      type: Boolean,
      default: false,
    },
    thumbnail: {
      type: [String, Object],
      default: '',
    },
    boldLabel: {
      type: Boolean,
      default: false,
    },
    oneline: {
      type: Boolean,
      default: false,
    },
  },
  render(h, ctx) {
    const props = ctx.props;
    const slots = ctx.slots();

    let label;
    const { thumbnail, showThumbnail, boldLabel, oneline } = props;
    if (props.label) {
      label = (
        <div
          class={ {
            'el-text--caption': true,
            'el-text--color-fixed-light': true,
            'el-card-item__caption-bold': boldLabel,
          } }
        >
          { props.label }
        </div>
      );
    }

    const defaultContent = showThumbnail ? (
      <el-row
        style={{ width: '100%' }}>
        <el-col
          span={ 1 }
          style={{ minWidth: '72px' }} >
            <img src={ thumbnail } style={{ width: '48px' }}/>
        </el-col>
        <el-col span={ 19 }>
          <div
            class={{
              'el-card-item__right-border': props.rightBorder,
              'el-card-item__left': true,
              'el-text--body-32': true,
            }}>
            { label }
            <div>{ slots.default }</div>
          </div>
        </el-col>
      </el-row>
    ) : oneline ? (
      <el-row
        type="flex"
        align="middle"
        class={{ 'el-row--fullscreen': true }}
        gutter={ 16 }
      >
        <el-col
          span={ 8 }
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <span
            class={{
              'el-card-item__right-border': props.rightBorder,
              'el-card-item__left': true,
              'el-text--body-32': true,
            }}>
            { label }
          </span>
        </el-col>
        <el-col span={ 16 }>
          <span
            class={{
              'el-card-item__left': true,
              'el-text--body-32': true,
              'el-text--ellipsis': true,
            }}>
            { slots.default }
          </span>
        </el-col>
      </el-row>
    ) : (
      <div
        class={{
          'el-card-item__right-border': props.rightBorder,
          'el-card-item__left': true,
          'el-text--body-32': true,
        }}>
        { label }
        <div>{ slots.default }</div>
      </div>
    );

    const content = (
      <el-row
        type="flex"
        align="middle"
        justify={ slots.default ? 'space-between' : 'end' }>
        {
          slots.default ? (
            defaultContent
          ) : null
        }
        {
          slots.right ? (
            <div
              class="el-card-item__right ml-24">
              { slots.right }
            </div>
          ) : null
        }
        {
          slots.rightCol ? (
            <div
              class="el-card-item__col-right">
              { slots.rightCol }
            </div>
          ) : null
        }
      </el-row>
    );

    return (
      <div
        class={ {
          'el-card-item': true,
          [`${props.paddingX} ${props.narrow ? 'py-7' : props.paddingY}`]: true,
          'is-highlight': props.highlight,
          'is-divided': props.divided,
          'is-divided-bottom': props.dividedBottom,
        } }>
        { content }
      </div>
    );
  },
};
</script>
